import script from "./salesByTeam.vue?vue&type=script&setup=true&lang=js"
export * from "./salesByTeam.vue?vue&type=script&setup=true&lang=js"

import "./salesByTeam.vue?vue&type=style&index=0&id=822bf482&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-822bf482"]])

export default __exports__